module.exports = __webpack_public_path__ + "img/globe-duotone-solid.ae4d1c59.svg";